import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

export default function About() {
  const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.1 });

  return (
    <section id="about" style={{ marginBottom: '128px' }}>
      <motion.div
        ref={ref}
        initial={{ opacity: 0, y: 20 }}
        animate={inView ? { opacity: 1, y: 0 } : {}}
        transition={{ duration: 0.5 }}
      >
        <h2
          style={{
            fontSize: '12px',
            fontWeight: 700,
            letterSpacing: '0.1em',
            textTransform: 'uppercase',
            color: '#60a5fa',
            marginBottom: '40px',
          }}
        >
          About
        </h2>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '16px', fontSize: '16px', lineHeight: 1.7, color: '#94a3b8' }}>
          <p>
            I'm a full stack software engineer with a background in structural engineering. I build scalable web applications and data-driven platforms, with a focus on clean architecture and intuitive user experiences.
          </p>
          <p>
            Currently, I'm building{' '}
            <a href="https://www.winacontract.com/" target="_blank" rel="noopener noreferrer" style={{ color: '#60a5fa', textDecoration: 'none', }} onMouseEnter={(e) => e.currentTarget.style.opacity = '0.8'} onMouseLeave={(e) => e.currentTarget.style.opacity = '1'}>WinAContract</a> at{' '}
            <a href="https://axionsolutionsltd.com/" target="_blank" rel="noopener noreferrer" style={{ color: '#60a5fa', textDecoration: 'none', }} onMouseEnter={(e) => e.currentTarget.style.opacity = '0.8'} onMouseLeave={(e) => e.currentTarget.style.opacity = '1'}>Axion Solutions</a> — a centralised search engine for UK public procurement data, helping businesses find opportunities faster.
          </p>
          <p>
            My path into software engineering started with a structural engineering internship at Arup, where I wrote Python scripts to automate analysis workflows. That experience showed me what was possible with code, leading me to a software engineering bootcamp at General Assembly and eventually into full-stack development.
          </p>
          <p>
            Outside of work, I play basketball, make music, and edit videos.
          </p>
        </div>
      </motion.div>
    </section>
  );
}
